// extracted by mini-css-extract-plugin
export var title = "section-title-module--title--34Tvm";
export var subtitle = "section-title-module--subtitle--aQ0uF";